import styled, { css } from 'styled-components'

export const FormItemHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    height: 40px;
`

export const FormLabel = styled.label<{ required?: boolean }>`
    font-weight: 600;
    font-size: 14px;
    ${({ required }) =>
        required &&
        css`
            &::after {
                content: ' *';
                color: var(--color-red-500);
            }
        `}
`

export const DeleteButton = styled.button.attrs({ type: 'button' })`
    display: inline-flex;
    outline: none;
    border: none;
    padding: 2px;
    color: var(--color-gray-500);
`

export const ErrorMessage = styled.div`
    color: var(--color-red-500);
`
